import { useMemo } from 'react';
import { deriveStats, type MyStats } from '../content/stats';
import { useCountedSessions } from './use-marks';
import { todayIso } from './use-today';

/**
 * The Account tab's numbers and achievements, derived from the person's sessions in Core and
 * the marks leaders made for them.
 */
export function useMyStats() {
  const sessions = useCountedSessions();
  const today = todayIso();
  const data = useMemo(
    (): MyStats | undefined => (sessions.data ? deriveStats(sessions.data, today) : undefined),
    [sessions.data, today],
  );
  return { data, isLoading: sessions.isLoading, error: sessions.error };
}
